import React from "react";
import { View, SafeAreaView, Pressable } from "react-native";
import { useRouter } from "expo-router";
import StyledText from "../components/common/ui/styled-text";
import { ArrowLeft } from "lucide-react-native";
import Billing from "../components/feature/billing/billing";

export default function BillingPage() {
  const router = useRouter();

  const handleBackPress = () => {
    router.back();
  };

  return (
    <SafeAreaView className="flex-1 bg-white">
      {/* Page Header */}
      <View className="flex-row items-center justify-between p-4 border-b border-gray-200 h-[64px]">
        <Pressable onPress={handleBackPress} className="flex-row items-center">
          <ArrowLeft size={20} />
          <StyledText className="ml-2 text-lg font-semibold">
            Billing
          </StyledText>
        </Pressable>
      </View>

      {/* Page Content */}
      <View className="flex-1 items-center overflow-y-auto p-4 sm:pl-20 lg:pl-4 w-full">
        <View className="w-full max-w-5xl">
          <Billing />
        </View>
      </View>
    </SafeAreaView>
  );
}
